import script from "./Applications.vue?vue&type=script&setup=true&lang=js"
export * from "./Applications.vue?vue&type=script&setup=true&lang=js"

import "./Applications.vue?vue&type=style&index=0&id=a09af840&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a09af840"]])

export default __exports__